"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _mapProductBoxProps = require("./mapProductBoxProps");
Object.keys(_mapProductBoxProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductBoxProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductBoxProps[key];
    }
  });
});
